import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon, Table } from 'semantic-ui-react';

import { IngredientFieldEnum as IngredientFields } from 'Common/FieldEnum';

const IngredientList = ({
  ingredients,
  instruction,
  handleAddIngredientClick,
}) =>
  ingredients.map((ingredient, index) => {
    return (
      <Table.Row key={`${ingredient[IngredientFields.Id]}-${index}`}>
        <Table.Cell>
          <Icon
            name="plus"
            onClick={() =>
              handleAddIngredientClick(
                ingredient[IngredientFields.Id],
                ingredient[IngredientFields.IngIndex],
                instruction
              )
            }
            link
          />
        </Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.CN_Code]}</Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.IngredientName]}</Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.Quantity1]}</Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.Measure1]}</Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.Quantity2]}</Table.Cell>
        <Table.Cell>{ingredient[IngredientFields.Measure2]}</Table.Cell>
      </Table.Row>
    );
  });

class IngredientsModal extends Component {
  static propTypes = {
    headerTitle: PropTypes.string.isRequired,
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
    ingredients: PropTypes.array.isRequired,
  };

  static defaultProps = {
    ingredients: [],
  };

  render() {
    const {
      headerTitle,
      modalProps,
      ingredients,
      instruction,
      handleAddIngredientClick,
    } = this.props;
    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header">
          {headerTitle}
          <Icon name="close" onClick={modalProps.onClose} link />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={1} />
                <Table.HeaderCell width={3}>Ingredient #</Table.HeaderCell>
                <Table.HeaderCell width={6}>Ingredient Name</Table.HeaderCell>
                <Table.HeaderCell width={1}>Quantity</Table.HeaderCell>
                <Table.HeaderCell width={2}>Measure</Table.HeaderCell>
                <Table.HeaderCell width={1}>Quantity</Table.HeaderCell>
                <Table.HeaderCell width={2}>Measure</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {Array.isArray(ingredients) && (
                <IngredientList
                  ingredients={ingredients}
                  instruction={instruction}
                  handleAddIngredientClick={handleAddIngredientClick}
                />
              )}
            </Table.Body>
          </Table>
        </Modal.Content>
      </Modal>
    );
  }
}

export { IngredientsModal };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/PreparationInstructions/IngredientsModal.js